<template>
	<div>
		<el-row :gutter="30">
			<el-col :span="6" class="sidebar">
				<router-link :to="{name: 'Add Lounger'}">
					<el-button type="primary" class="fluid">{{ $t('add') }} Leżak <i class="el-icon-plus"></i></el-button>
				</router-link>
			</el-col>
			<el-col class="box" :span="18">
				<div class="list__header">
					<p class="list__title">
						{{ getRouteName($route) }}
					</p>
				</div>
				<el-table :data="data"
						  highlight-current-row
						  v-loading="listLoading"
						  class="list__table"
						  style="width: 100%;">
					<el-table-column prop="id" label="id" width="80"></el-table-column>
					<el-table-column prop="type_display" label="typ"></el-table-column>
          <el-table-column prop="date" label="data"></el-table-column>
          <el-table-column prop="price_display" label="cena (zł)"></el-table-column>
          <el-table-column prop="quantity" label="ilość"></el-table-column>
					<el-table-column label="opcje" width="150" class="pull-right">
						<template slot-scope="scope" class="pull-right">
							<router-link :to="{name: 'Edit Lounger', params: {id: scope.row.id}}">
								<el-button size="small" :title="$t('edit')">
									<i class="el-icon-edit"></i>
								</el-button>
							</router-link>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
	</div>
</template>
<script>
	import { Lounger } from '@/api/';

	export default {
		data () {
			return {
				data: [],
				listLoading: false,
				service: Lounger
			}
		},
		methods: {
			fetchData () {
				this.listLoading = true;
				this.service.fetch().then(response => {
					this.data = response.data;
					this.listLoading = false;
				})
			},
			async handleDelete (index, row) {
				await this.$confirm(this.$i18n.t('deleteConfirmation'), this.$i18n.t('delete'), {
					type: 'warning'
				})

				this.listLoading = true;
				await this.service.delete(row.id)

				this.listLoading = false;
				this.$message({
					message: 'Element został usunięty',
					type: 'success'
				})

				this.fetchData()
			}
		},
		mounted () {
			this.fetchData()
		}
	}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// LoungerList.vue?ee14b630